// The coach app is everything under /coach. A substring check would also match
// member URLs such as /m/settings/coaching-notes.
export const isCoachAppPath = (pathname: string): boolean =>
  pathname === '/coach' || pathname.startsWith('/coach/');
